import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  components: {},
  props: [],
  data: function data() {
    return {
      show: false,
      options: {
        target: this.$base.uploadUrl,
        // withCredentials: true,
        prioritizeFirstAndLastChunk: true,
        testChunks: true,
        generateUniqueIdentifier: function generateUniqueIdentifier(chunk) {
          // const str = this.$options.filters.roll(12, "-", 4);
          return chunk.uid;
        },
        checkChunkUploadedByResponse: function checkChunkUploadedByResponse(chunk, message) {
          var objMessage = JSON.parse(message);

          if (objMessage.resData.skipUpload) {
            return true;
          }

          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        }
      },
      fileStatusText: {
        success: "完成",
        error: "失败",
        uploading: "上传中",
        paused: "暂停",
        waiting: "等待"
      },
      // 上传完成后的id集合
      ids: [],
      fileList: []
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {
    var authorization = "bearer " + this.$keycloak.token;
    this.options.headers = {
      Accept: "application/json",
      Authorization: authorization,
      token: this.userToken
    };
  },
  mounted: function mounted() {},
  methods: {
    addFiles: function addFiles(fileList) {
      var _this = this;

      this.clearFileList();
      this.show = true;
      this.$nextTick(function () {
        _this.fileList = fileList;

        var _iterator = _createForOfIteratorHelper(fileList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            _this.$refs.uploader.uploader.addFile(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    complete: function complete() {
      // Bus.$emit("successUpload", this.ids);
      this.$emit("complete", this.ids);
    },
    fileSuccess: function fileSuccess(rootFile, file, message, chunk) {
      var type = "";
      var msg = JSON.parse(message);

      if (msg.resCode !== 0) {
        this.$message.warning(file.name + "上传失败！");
        type = "error";
      } else {
        type = "success";
      }

      this.ids.push({
        uid: file.uniqueIdentifier,
        type: type,
        fileName: file.name
      });
    },
    fileError: function fileError(rootFile, file, message, chunk) {
      this.ids.push({
        id: file.uniqueIdentifier,
        type: "error"
      });
    },
    hideView: function hideView() {
      this.show = false;
      this.ids = [];
      this.$refs.uploader.uploader.cancel();
    },
    clearFileList: function clearFileList() {
      this.ids = [];
      this.$refs.uploader.uploader.cancel();
    },
    fileAdded: function fileAdded(file) {},
    clearFn: function clearFn() {}
  },
  watch: {},
  destroyed: function destroyed() {}
};